import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { usePixiApp } from '../../services/pixiApp/pixiAppProvider';
import RoomsManager from '../../features/rooms/managers/roomsManager';
import DecksManager from '../../features/decks/managers/decksManager';
import { useApi } from '../../services/api/ApiProvider';
import { fetchRooms, deleteDeck as apiDeleteDeck } from '../../services/api/apiService';

const RoomsPage = () => {
  const { app } = usePixiApp();
  const pixiContainerRef = useRef(null);
  const roomsManagerRef = useRef(null);
  const decksManagerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { decks, fetchDecks } = useApi();

  const createRoom = () => {
    console.log('create room');
    const roomName = prompt('room name');
    if (!roomName) return;

    navigate(`/game/${roomName}`);
  };

  const joinRoom = (room) => {
    if (room.users.length === 2) {
      return;
    }
    
    console.log('join room', room);
    navigate(`/game/${room.name}`);
  };

  const refreshRooms = async (setRoomsFn) => {
    console.log('refresh rooms');
    const rooms = await fetchRooms();
    setRoomsFn(rooms);
  };

  const openDecksPage = () => {
    navigate('/rooms#decks');
  };

  const closeDecks = () => {
    navigate(-1);
  };

  const createNewDeck = () => {
    navigate('/decks/create');
  };

  const editDeck = (deckId) => {
    navigate(`/decks/edit/${deckId}`);
  };

  const confirmDeleteDeck = async (deckId) => {
    await apiDeleteDeck(deckId);
    await fetchDecks();
  };

  useEffect(() => {
    const initRoomsPage = async () => {
      if (app && pixiContainerRef.current) {
        pixiContainerRef.current.addEventListener('touchstart', (e) => e.preventDefault(), { passive: false });
        
        roomsManagerRef.current = new RoomsManager();
        roomsManagerRef.current.attachToPixiApp(app);
        pixiContainerRef.current.appendChild(app.canvas);

        const decksManager = new DecksManager(decks);
  
        await Promise.all([
          roomsManagerRef.current.loadAssets(),
          decksManager.loadAssets(),
        ]);
           
        roomsManagerRef.current.removeLoadingText();
        roomsManagerRef.current.buildRoomsPage();

        decksManager.buildMainLayout();
        decksManager.buildDeckList();

        decksManagerRef.current = decksManager;

        roomsManagerRef.current.onCreateRoomButtonClick = createRoom;
        roomsManagerRef.current.onRefreshRoomsButtonClick = () => refreshRooms(roomsManagerRef.current.setRoomsList.bind(roomsManagerRef.current));
        roomsManagerRef.current.onRoomContainerClick = joinRoom;
        roomsManagerRef.current.onDecksButtonClick = openDecksPage;

        decksManagerRef.current.onNewDeckButtonClick = createNewDeck;
        decksManagerRef.current.onDeckContainerTap = editDeck;
        decksManagerRef.current.onConfirmDeleteDeck = confirmDeleteDeck;
        decksManagerRef.current.onBackButtonClick = closeDecks;

        if (location.hash === '#decks') {
          decksManagerRef.current.attachToPixiApp(app);
        }

        const rooms = await fetchRooms();
        roomsManagerRef.current.setRoomsList(rooms);
      }
    }

    initRoomsPage();

    return () => {
      if (roomsManagerRef.current && app) {
        roomsManagerRef.current.detachFromPixiApp(app);
      }

      if (decksManagerRef.current && app) {
        decksManagerRef.current.detachFromPixiApp(app);
      }
    };
  }, [app, pixiContainerRef]);

  useEffect(() => {
    if (decksManagerRef.current && decks) {
      decksManagerRef.current.setDecks(decks);
    }
  }, [decks]);

  useEffect(() => {
    if (!decksManagerRef.current) return;
    
    if (location.hash === '#decks') {
      decksManagerRef.current.attachToPixiApp(app);
    } else if (location.hash === '') {
      decksManagerRef.current.detachFromPixiApp(app);
    }
  }, [location]);

  return (
    <div style={{ width: '100dvw', height: '100dvh', overflow: 'hidden' }} ref={pixiContainerRef} />
  );
};

export default RoomsPage; 